import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MulherCurriculo from '../assets/img/cadastro/mulher-curriculo.png';
import HomemCurriculo from '../assets/img/cadastro/homem-curriculo.png';
import BackgroundCinza from '../assets/img/cadastro/background-cinza.png';
import BudgetModal from './components/BudgetModal';
import ResumeModal from './components/ResumeModal';

const Cadastro = () => {
    const [showResumeModal, setShowResumeModal] = useState(false);
    const [showBudgetModal, setShowBudgetModal] = useState(false);

    const { t } = useTranslation('register'); // Usando o namespace 'register'

    return (
        <>
            <div className="header-spacer-cadastro"></div>
            
            <section className="container register-container">
                <div className="background-container">
                    <img src={BackgroundCinza} alt="Fundo cinza" />
                </div>
                <div className="youngwoman-img"><img src={MulherCurriculo} alt="Mulher com currículo" /></div>
                <div className="youngman-img"><img src={HomemCurriculo} alt="Homem com currículo" /></div>

                <div className="options-container">
                    <div className="company-container">
                        <h2>{t('title_company')}</h2>
                        <h2>{t('subtitle_company')}</h2>
                        <p>{t('description_company')}</p>
                        <button className="company-button" onClick={() => setShowBudgetModal(true)}>{t('button_company')}</button>
                    </div>
                    <div className="candidate-container">
                        <h2>{t('title_candidate')}</h2>
                        <h2>{t('subtitle_candidate')}</h2>
                        <p>{t('description_candidate')}</p>
                        <button className="candidate-button" onClick={() => setShowResumeModal(true)}>{t('button_candidate')}</button>
                    </div>
                </div>
            </section>

            {/* Modais */}
            <BudgetModal isOpen={showBudgetModal} onClose={() => setShowBudgetModal(false)} />
            <ResumeModal isOpen={showResumeModal} onClose={() => setShowResumeModal(false)} />
        </>
    );
};

export default Cadastro;
